<div class="full-page-container">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="'marketplace.page.title' | translate"></fgb-banner>
  </div>

  <fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

  <div class="container mt-4">
    <fgbcl-marketplace-list
      [isList]="true"
      [marketplaceItemView]="true"
      [marketplaceItemTypes]="[0, 1, 2]"
      [showSortBar]="true"
      [showStatusFilter]="true"
      [defaultSort]="2"
    ></fgbcl-marketplace-list>
  </div>
</div>
